import React, {Component} from "react";
import * as Yup from "yup";
import _ from "lodash";
import {connect} from "react-redux";

import {FormGridField} from "../../../../../utils/forms/components/FormGrid";
import Form from "../../../../../utils/forms/components/Form";
import {GamesActionCreators} from "../../../actions/actionCreators";
import {gamesStoreSelectors} from "../../../store/store";
import {ActionCreator} from "../../../../../actions/actions";

import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {CreationModes} from "../../../reducers/creationMode.reducer";

import "./CreateGame.component.scss";
import FormSelect from "../../../../../utils/forms/components/FormSelect";

export function gameFormFields({
                                   clients,
                                   series,
                                   platforms,
                                   gameTypes,
                                   trademarks,
                                   features,
                                   values
                               }): FormGridField[] {
    const isDisabled =
        values == null || (values !== null && !values.hasOwnProperty("client")) ||
        values.client == undefined ||
        values.client == null ||
        values.client == "";
    return [
        {
            name: "name",
            fieldType: "input",
            fieldOptions: {
                id: "name",
                placeholder: "Name",
                label: "Name"
            },
            validation: Yup.string()
                .required("Field is required.")
                .max(50, "Max. 50 characters."),
            columnClass: "col-12"
        },
        {
            name: "software_house",
            fieldType: "select",
            fieldOptions: {
                id: "software_house",
                noValueLabel: "Choose a option...",
                label: "Software House",
                items: [
                    {label: "FBM Brasil", value: 2},
                    {label: "Fabamaq", value: 1}
                ]
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-6"
        },
        {
            name: "type",
            fieldType: "select",
            fieldOptions: {
                id: "type",
                noValueLabel: "Choose a Type...",
                label: "Game Type",
                items: [
                    {label: "Bingo", value: 0},
                    {label: "Spins", value: 1},
                    {label: "Lotto", value: 2},
                    {label: "Keno", value: 3}
                ]
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-6"
        },
        {
            name: "client",
            fieldType: "select",
            fieldOptions: {
                id: "client",
                noValueLabel: "Choose a client...",
                label: "Client",
                items: clients
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-6"
        },
        {
            name: "feature",
            fieldType: "select",
            fieldOptions: {
                id: "feature",
                noValueLabel: "Choose a Feature...",
                label: "Feature",
                items: features,
                disabled: isDisabled
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-6"
        },
        {
            name: "platform",
            fieldType: "select",
            fieldOptions: {
                id: "platform",
                noValueLabel: "Choose a Platform...",
                label: "Platform",
                items: platforms,
                disabled: isDisabled
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-6"
        },
        {
            name: "series",
            fieldType: "select",
            fieldOptions: {
                id: "series",
                noValueLabel: "Choose a Series...",
                label: "Series",
                items: series,
                disabled: isDisabled
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-6"
        },
        {
            name: "game_type",
            fieldType: "select",
            fieldOptions: {
                id: "game_type",
                noValueLabel: "Choose a product type...",
                label: "Product Type",
                items: gameTypes,
                disabled: isDisabled
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-6"
        },
        {
            name: "trademark",
            fieldType: "select",
            fieldOptions: {
                id: "trademark",
                noValueLabel: "Choose a trademark...",
                label: "Trademark",
                items: trademarks,
                disabled: isDisabled
            },
            validation: Yup.string().required("Field is required."),
            columnClass: "col-6"
        }
    ];
}

export function gameFormFieldEdit({
                                      clients,
                                      series,
                                      platforms,
                                      gameTypes,
                                      trademarks,
                                      features,
                                      values
                                  }): FormGridField[] {
    return [
        ...gameFormFields({
            clients,
            series,
            platforms,
            gameTypes,
            trademarks,
            features,
            values
        }),
        {
            name: "deprecated",
            fieldType: "switch",
            fieldOptions: {
                id: "deprecated",
                label: "Deprecated"
            },
            columnClass: "col-12"
        }
    ];
}

export interface CreateGameProps {
    creatingGame: {
        values: any;
        isValid: boolean;
    };
    creationMode: any;
    updateCreatingGame: ActionCreator;
    clearCreateGame: ActionCreator;
    editGame: any;
    createGame: any;
    attributes: any;
}

class CreateGame extends Component<CreateGameProps> {
    form: React.RefObject<FormSelect>;

    constructor(props) {
        super(props);

        this.form = React.createRef();

        if (this.props.creationMode == CreationModes.EDIT_GAME) {
            let values = {...this.props.creatingGame.values};
            values.image_base64 = "previous";
            this.props.updateCreatingGame(values, true);
        }
    }

    onCreate = () => {
        let game = {...this.props.creatingGame.values};
        game.file = game.image_base64;
        delete game.image_base64;
        delete game.image;
        this.props.createGame(game);
    };

    onEdit = () => {
        let game = {...this.props.creatingGame.values};
        if (game.image_base64 !== "previous") {
            game.file = game.image_base64;
        }
        delete game.image_base64;
        delete game.image;
        this.props.editGame(game);
    };

    formChange = e => {
        let values = {...e.values};
        let isFormValid = e.isValid;

        //let hasImage = false;
        if (
            this.props.creatingGame &&
            this.props.creatingGame.values &&
            this.props.creatingGame.values.image_base64
        ) {
            //hasImage = true;
            values.image_base64 = this.props.creatingGame.values.image_base64;
        }

        this.props.updateCreatingGame(values, isFormValid); //&& hasImage);
    };

    handleFile = e => {
        let values = {...this.props.creatingGame.values};
        values.image_base64 = e[0];

        this.props.updateCreatingGame(
            values,
            this.form.current.state.validation.isValidSync(values) &&
            values.image_base64
        );
    };

    render() {
        const hasClient =
            this.props.creatingGame &&
            !(
                !this.props.creatingGame.values.hasOwnProperty("client") ||
                this.props.creatingGame.values["client"] == undefined ||
                this.props.creatingGame.values["client"] == null ||
                this.props.creatingGame.values["client"] == ""
            );

        const filtered = att => {
            return !(hasClient &&
                att.client.id !== this.props.creatingGame.values.client);
        };

        const formProps = {
            clients: this.props.attributes.clients && this.props.attributes.clients.results ? this.props.attributes.clients.results.map(client => {
                return {
                    label: client.name,
                    value: client.id
                };
            }) : [],
            series: this.props.attributes.series && this.props.attributes.series.results ? this.props.attributes.series.results.filter(filtered).map(att => {
                return {
                    label: att.name,
                    value: att.id
                };
            }) : [],
            platforms: this.props.attributes.platforms && this.props.attributes.platforms.results ? this.props.attributes.platforms.results
                .filter(filtered)
                .map(att => {
                    return {
                        label: att.name,
                        value: att.id
                    };
                }) : [],
            gameTypes: this.props.attributes.gameTypes && this.props.attributes.gameTypes.results ? this.props.attributes.gameTypes.results
                .filter(filtered)
                .map(att => {
                    return {
                        label: att.name,
                        value: att.id
                    };
                }) : [],
            trademarks: this.props.attributes.trademarks && this.props.attributes.trademarks.results ? this.props.attributes.trademarks.results
                .sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
                .filter(filtered)
                .map(att => {
                    return {
                        label: att.name,
                        value: att.id
                    };
                }) : [],
            features: this.props.attributes.features && this.props.attributes.features.results ? this.props.attributes.features.results
                .filter(filtered)
                .map(att => {
                    return {
                        label: att.name,
                        value: att.id
                    };
                }) : [],
            values: this.props.creatingGame
                ? this.props.creatingGame.values
                : null
        };

        const fields =
            this.props.creationMode === CreationModes.EDIT_GAME
                ? gameFormFieldEdit(formProps)
                : gameFormFields(formProps);

        return (
            <div id="create-game">
                <div className="create-content">
                    <div className="new-game-card">
                        <FormSelect
                            ref={this.form}
                            fields={fields}
                            initialValues={
                                this.props.creatingGame
                                    ? this.props.creatingGame.values
                                    : null
                            }
                            onChange={this.formChange}
                        />
                        <div id="upload" className="row">
                            <div className="col-12">
                                <div className="label-tooltip">
                                    <label className="label">Image</label>
                                </div>
                                <Components.FileBox
                                    displayMessage={
                                        this.props.creationMode ==
                                        CreationModes.EDIT_GAME
                                            ? "Drag and drop to change current"
                                            : "Drag and drop game image"
                                    }
                                    multipleFilesAllowed={false}
                                    displayIcon={""}
                                    onFilesChange={this.handleFile}
                                    files={[]}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <button
                                    className="red-btn create-btn"
                                    disabled={
                                        !this.props.creatingGame ||
                                        !this.props.creatingGame.isValid
                                    }
                                    onClick={this.props.creationMode == CreationModes.ADD_GAME ?
                                        this.onCreate :
                                        this.onEdit}
                                >
                                    {this.props.creationMode == CreationModes.ADD_GAME ? "Create" : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creationMode: gamesStoreSelectors.creationMode(state),
    creatingGame: gamesStoreSelectors.creatingGame(state)
});

const mapDispatchToProps = {
    updateCreatingGame: GamesActionCreators.updateCreatingGame,
    clearCreateGame: GamesActionCreators.clearCreateGame
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateGame);
